import { render, staticRenderFns } from "./Sport.vue?vue&type=template&id=25ddc2d9&scoped=true"
import script from "./Sport.vue?vue&type=script&lang=js"
export * from "./Sport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ddc2d9",
  null
  
)

export default component.exports